<script>
    import UserListBox from './UserListBox.svelte';
    import PlayerChoice from './PlayerChoice.svelte';
    import MapsLog from './MapsLog.svelte';
    import Instruction from './Instruction.svelte';
    import TeamGoal from './TeamGoal.svelte';
    import TrainerChoice from './TrainerChoice.svelte';
    import ResultsTable from './ResultsTable.svelte';
    import CurrentRules from './CurrentRules.svelte';
    import EndGame from './EndGame.svelte';
    import Swal from 'sweetalert2';
    import { texts } from './texts.js';
    import io from 'socket.io-client';
    import { teamData } from '../multi/teamData';
    let lang;
    let game = '';
    let gameSocket = '';
    export let trainerHurried = false;
    export let userName = '';
    let teamName = ''; // teamA, teamB..  trener
    let teamColour = ''; // pomaranczowi, zieloni...
    let team = '';
    export let userList = [];
    let decisions = {
        teamA: 'czekamy',
        teamB: 'czekamy',
        teamC: 'czekamy',
        teamD: 'czekamy',
    };
    const activeMaps = {
        teamA: false,
        teamB: false,
        teamC: false,
        teamD: false,
    };
    let platools = {}; // functions for manipulating playerchoice component
    let maptools = {}; // functions for manipulatimg MapsLog component
    let gameData = {}; // whole game object
    let currMaps = []; // maps transactions from current round
    export let tavernClass = 'tawerna';
    export let eventClass = 'wydarzenie';
    export let logClass = 'log';
    export let instrVisible = false;
    export let tgVisible = false;
    initUser();
    $: if (gameData.gameRound > 3) {
        tavernClass = 'tawerna1';
        eventClass = 'wydarzenie1';
    }

    async function initUser() {
        let connectionData = new URL(window.location);
        let gameLocation = connectionData.searchParams.get('game');
        let teamLocation = connectionData.searchParams.get('team');
        if (!gameLocation || !teamLocation) {
            await Swal.fire(
                'Błedny adres gry, skontaktuj się z trenerem/Wrong game address, please ask your facilitator'
            );
            return;
        }
        game = gameLocation;
        const inputOptions = {
            teamA: teamData.teamA.code,
            teamB: teamData.teamB.code,
            teamC: teamData.teamC.code,
            teamD: teamData.teamD.code,
            trener: 'trener',
        };
        for (let prop in inputOptions) {
            if (teamLocation.toLowerCase() === inputOptions[prop]) {
                team = prop;
                prop === 'trener'
                    ? (teamColour = 'trener')
                    : (teamColour = teamData[prop].label);
            }
        }

        if (!team) {
            await Swal.fire('Nie ma takiego teamu!');
            return;
        }

        gameSocket = io({
            query: {
                game,
            },
        });
        gameSocket.on('access allowed', async function () {
            const { value: player } = await Swal.fire({
                title: 'Input your nickname/Podaj swoje imię/pseudonim',
                input: 'text',
                allowOutsideClick: false,
                inputValidator: (value) => {
                    if (!value) {
                        return '!';
                    }
                    if (value.length > 16) {
                        return 'max 16 znaków/max 16 chars';
                    }
                },
            });
            gameLogin();
            newUserConnected(team, player, game);
        });
        gameSocket.on('access not allowed', async function () {
            await Swal.fire('gra nie istnieje/game does not exist');
            return;
        });
    }

    function gameLogin() {
        console.log('connectiong to the', game);

        gameSocket = io(`/${game}`);

        gameSocket.on('new user', function (data) {
            userList = data.users;
            gameData = data.game;
            lang = data.game.lang;
            decisions = data.decisions;
            currMaps = data.game.currMaps;
            currMaps.forEach((el) => {
                activeMaps[el[2]] = true;
            });
        });
        gameSocket.on('user disconnected', function (data) {
            userList = data;
        });
        gameSocket.on('new game', function (data) {
            gameData = data;
        });
        gameSocket.on('player decided', function (team, boy, girl) {
            decisions[team] = 'ok';
            if (teamName === team) {
                platools.otherPlayerDecided(boy, girl);
            }
        });
        gameSocket.on('player bought a map', function (data) {
            gameData = data.gameData;
            currMaps = data.gameData.currMaps;
            if (data.data.nick === teamName) {
                maptools.weBoughtMap(data.data.mapForColour);
            }
            activeMaps[data.data.mapFor] = true;
        });
        gameSocket.on('next round', function (data) {
            decisions = {
                teamA: 'czekamy',
                teamB: 'czekamy',
                teamC: 'czekamy',
                teamD: 'czekamy',
            };
            if (teamName != 'trener') {
                platools.cleanUp();
                maptools.cleanUpMap();
            }
            gameData = data;
            currMaps = data.currMaps;
            trainerHurried = false;
            for (let prop in activeMaps) {
                activeMaps[prop] = false;
            }
        });
        gameSocket.on('end game', function (data) {
            gameData = data;
            currMaps = data.currMaps;
            logClass = 'log1';
        });
        gameSocket.on('start round', function (data) {
            gameData.isRoundOn = data;
        });
        gameSocket.on('hurry players', function () {
            trainerHurried = true;
        });
    }

    const newUserConnected = (team, player, game) => {
        userName = player;
        teamName = team || `User${Math.floor(Math.random() * 1000000)}`;
        // console.log(userName, '#', teamColour, '#', teamName);
        let userData = { game, userData: [teamName, userName] };
        console.log('going for new user!');
        gameSocket.emit('new user', userData);
    };
    $: console.log('lang', lang);
</script>

<svelte:head>
    <title>{lang ? texts[lang].black_ines_header : '...'}</title>
</svelte:head>

{#if lang}
    <body>
        <div class="header">
            <h1 class="header-item">{texts[lang].main_header}</h1>
            <i class="fas fa-skull-crossbones fa-2x header-item" />
            <!-- <h1>Numer rozgrywki</h1> -->
            <i
                class="far fa-compass fa-2x header-item"
                on:click={() => {
                    instrVisible = true;
                }}
            />
        </div>
        <!-- główny container -->

        <div class="container">
            <!-- header -->

            <!-- obszar aktualnej tury -->
            {#if !gameData.isGameEnd}
                <div class="main">
                    <CurrentRules
                        {lang}
                        rules={gameData.rulesText}
                        {eventClass}
                        isGameOn={gameData.isGameOn}
                        isRoundOn={gameData.isRoundOn}
                        lastRules={gameData.lastRulesText}
                        round={gameData.gameRound}
                    />
                    <MapsLog
                        {lang}
                        {teamName}
                        {teamColour}
                        maps={currMaps}
                        round={gameData.gameRound}
                        isRoundOn={gameData.isRoundOn}
                        isGameEnd={gameData.isGameEnd}
                        bind:tavernClass
                        bind:eventClass
                        bind:mapTools={maptools}
                        on:map-bought={(ev) => {
                            gameSocket.emit('map bought', ev.detail);
                        }}
                    />
                    <div class={tavernClass}>
                        <h2>
                            {texts[lang].tavern_header}
                            <i class="fas fa-beer" />
                        </h2>
                        {#if teamName === 'trener'}
                            <TrainerChoice
                                {lang}
                                isGameOn={gameData.isGameOn}
                                isGameEnd={gameData.isGameEnd}
                                isRoundOn={gameData.isRoundOn}
                                maps={currMaps}
                                isHurried={trainerHurried}
                                {decisions}
                                on:new-game={() => {
                                    gameSocket.emit('new_game');
                                }}
                                on:new-round={() => {
                                    gameSocket.emit('new_round');
                                }}
                                on:start-round={() => {
                                    gameSocket.emit('start_round');
                                }}
                                on:hurry-players={() => {
                                    gameSocket.emit('hurry_players');
                                }}
                            />
                        {:else if teamName.includes('team') && gameData.isGameOn}
                            <PlayerChoice
                                {lang}
                                {userName}
                                {teamName}
                                {decisions}
                                {teamColour}
                                {trainerHurried}
                                isRoundOn={gameData.isRoundOn}
                                bind:tools={platools}
                                round={gameData.gameRound}
                                on:decision-made={(ev) => {
                                    gameSocket.emit('decision', ev.detail);
                                }}
                            />
                        {:else}
                            <p>...</p>
                        {/if}
                    </div>
                </div>
            {/if}
            <!-- obszar - przebieg gry -->
            <div class={logClass}>
                {#if gameData.isGameOn || gameData.isGameEnd}
                    <ResultsTable results={gameData} {lang} {teamName}
                        >{#if gameData.isGameEnd}
                            <EndGame
                                {lang}
                                ines={gameData.ines}
                                pirate={gameData.pirate}
                            />
                        {/if}</ResultsTable
                    >
                {/if}
            </div>
            <!-- aside - dane graczy -->
            <UserListBox
                {activeMaps}
                {userList}
                {decisions}
                {teamColour}
                {userName}
                {lang}
                bind:tgVisible
                round={gameData.gameRound}
                isGameOn={gameData.isGameOn}
                isGameEnd={gameData.isGameEnd}
            />
            <!-- popupy z instrukcjami -->
            {#if instrVisible}
                <Instruction bind:instrVisible {lang} />
            {/if}
            {#if tgVisible}
                <TeamGoal bind:tgVisible {teamColour} {lang} />
            {/if}
        </div></body
    >
{/if}
